import { AnalyticsField } from '@/store/analytics/utils/enums'

export const ANALYTICS_DELAY_TO_NOTIFICATE = 5

export const ANALYTICS_DATE_STORAGE_KEY = 'ANALYTICS_DATE'

export const ANALYTICS_PERIOD_NAMING = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  quarter: 'Quarterly',
  year: 'Yearly',
}

export const ANALYTICS_CAPTIONS = {
  [AnalyticsField.DATE]: 'Date',

  [AnalyticsField.ROOT_ID]: 'Root',

  [AnalyticsField.ASSET_ID]: 'Asset',
  [AnalyticsField.ASSET_TYPE]: 'Asset Type',
  [AnalyticsField.ACCOUNT_ID]: 'Account',
  [AnalyticsField.ACCOUNT_TYPE]: 'Account Type',

  [AnalyticsField.CATEGORY_ACCOUNT_ID]: 'Category Account',
  [AnalyticsField.CATEGORY_ACCOUNT_TYPE]: 'Category Account Type',

  [AnalyticsField.CATEGORY]: 'Category',
  [AnalyticsField.SUBCATEGORY]: 'Subcategory',

  [AnalyticsField.POSITION_CLOSE]: 'Value',
  [AnalyticsField.POSITION_COST]: 'Cost',
  [AnalyticsField.POSITION_GAIN]: 'Gain',

  [AnalyticsField.D_POSITION_CLOSE]: 'Value Change',
  [AnalyticsField.D_POSITION_COST]: 'Cost Change',
  [AnalyticsField.D_POSITION_GAIN]: 'Gain Change',

  [AnalyticsField.AMOUNT]: 'Amount',
  [AnalyticsField.D_AMOUNT]: 'Amount Change',

  [AnalyticsField.ASSET_CLOSE]: 'Price',

  [AnalyticsField.VALUE_START]: 'Value start',
  [AnalyticsField.CAPITAL_FLOW]: 'Capital Flow',
  [AnalyticsField.VALUE_END]: 'Value End',
  [AnalyticsField.IRR]: 'IRR',
  [AnalyticsField.MOIC]: 'Multiple (MOIC)',

  [AnalyticsField.REALIZED_GAIN]: 'Realized',
  [AnalyticsField.UNREALIZED_GAIN]: 'Unrealized',
}

export const ANALYTICS_LIABILITIES_NAME = 'Liabilities'
